import { configureStore } from '@reduxjs/toolkit'
import ticketCountReducer from './features/counter'

export default configureStore({
    reducer: {
        counter: ticketCountReducer
    },
})
